import { createFileRoute } from "@tanstack/react-router";
import { cn } from "cn";
import z from "zod";
import ResponsiveWrapper from "@/components/ui/layout/box/responsive-wrapper";
import PublicLayout from "@/components/ui/layout/public-layout";
import { SignInOtp } from "@/features/auth/sign-in-otp";

export const Route = createFileRoute("/(auth)/sign-in-otp")({
  component: SignInOtpPage,
  validateSearch: z.object({
    method: z.enum(["phone", "email"]),
    identifier: z.string(),
    factorId: z.string(),
    redirect_url: z.string().optional(),
  }),
});

function SignInOtpPage() {
  return (
    <PublicLayout>
      <ResponsiveWrapper
        className={cn(
          /* sorted */
          "grow",
          "py-12",
          "sm:mx-auto sm:w-full sm:max-w-[25.5rem]",
        )}
      >
        <SignInOtp />
      </ResponsiveWrapper>
    </PublicLayout>
  );
}
